import React from "react";
import PropTypes from "prop-types";

import Text from "components/common/Text";
import Select from "components/common/Select";

import "./EncashmentRules.scss";

const rateTypeOptions = [
  { value: "daily wage", label: "daily wage" },
  { value: "monthly salary", label: "monthly salary" },
  { value: "fixed amount", label: "fixed amount" },
];

function EncashmentRules({ field, value: valueFromProps, name, setFormValues, isDisabled = false }) {
  const { labels } = field;
  const { rate: rateLabel, amount: amountLabel, rateType: rateTypeLabel } = labels || {};

  const amount = valueFromProps?.amount || "0";
  const rate = valueFromProps?.rate || "0";
  const rateType = valueFromProps?.rateType || "daily wage";

  const handleAmountChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        amount: e.target.value,
      },
    }));
  };

  const handleRateChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        rate: e.target.value,
      },
    }));
  };

  const handleRateTypeChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        rateType: newValue,
      },
    }));
  };

  return (
    <div className="encashment-rules-field">
      <div className="encashment-inputs">
        <div className="amount-input-container">
          <Text
            name="encashAmount"
            className="amount-input"
            type="text"
            value={amount}
            onChange={handleAmountChange}
            variant="outlined"
            size="small"
            label={amountLabel}
            hideHelperText
            disabled={isDisabled}
          />
          <span className="input-suffix">day(s)</span>
        </div>
        <div className="rate-input">
          <Text
            name="encashmentRate"
            type="text"
            value={rate}
            onChange={handleRateChange}
            variant="outlined"
            size="small"
            label={rateLabel}
            hideHelperText
            disabled={isDisabled}
          />
        </div>
        <div className="rate-type-container">
          <span className="rate-label">{rateTypeLabel}</span>
          <Select
            name="rateType"
            className="rate-type-select mt-025"
            value={rateType}
            onChange={handleRateTypeChange}
            options={rateTypeOptions}
            variant="outlined"
            size="small"
            label=""
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
}

EncashmentRules.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    labels: PropTypes.shape({
      amount: PropTypes.string,
      rate: PropTypes.string,
      rateType: PropTypes.string,
    }),
  }).isRequired,
  value: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rateType: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  setFormValues: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

EncashmentRules.defaultProps = {
  value: {},
  isDisabled: false,
};

export default EncashmentRules;
